import { Button } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import AnalyticsService from '../../services/AnalyticsService';
import { InvoicePaymentStore } from '../../stores/InvoicePaymentStore';
import { ITranslateStore } from '../../stores/TranslateStore';

interface IPrepaymentButtonProps {
  translateStore?: ITranslateStore;
  analyticsService?: AnalyticsService;
  invoicePaymentStore?: InvoicePaymentStore;
  style: 'notice' | 'normal';
}

@inject('translateStore', 'analyticsService', 'invoicePaymentStore')
@observer
export default class PrepaymentButton extends React.Component<IPrepaymentButtonProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const analyticsService = this.props.analyticsService;

    let type;
    let size;

    if (this.props.style === 'notice') {
      type = 'primary';
      size = 'small';
    }

    return (
      <Button
        text={translate('shared.payment-modal.make-prepayment')}
        type={type}
        size={size}
        onClick={() => {
          this.props.invoicePaymentStore.makePrepayment();
          analyticsService.unpaidInvoicesMakePrepayment();
        }}
      />
    );
  }
}
